import Vue from "vue";
import VueAxios from "vue-axios";

window.axios = require( 'axios' );

window.axios.defaults.headers.common[ 'X-Requested-With' ] = 'XMLHttpRequest';

window.axios.defaults.baseURL = '/api/v1';

let token = document.head.querySelector( 'meta[name="csrf-token"]' );

if( token ) {
    window.axios.defaults.headers.common[ 'X-CSRF-TOKEN' ] = token.content;
} else {
    console.error( 'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token' );
}

Vue.use( VueAxios, axios );
